<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M11.4297 0.571289H4.57254C3.94137 0.571289 3.42969 1.08296 3.42969 1.71415V14.2856C3.42969 14.9168 3.94137 15.4284 4.57254 15.4284H11.4297C12.0609 15.4284 12.5725 14.9168 12.5725 14.2856V1.71415C12.5725 1.08296 12.0609 0.571289 11.4297 0.571289Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.42941 4H0.572266"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.42941 8H0.572266"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.42941 12H0.572266"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4294 4H12.5723"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4294 8H12.5723"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4294 12H12.5723"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.42969 12H9.7154"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
